export const getMapsUrl = (address: string) => {
    if (address) {
        return `https://www.google.com/maps/search/${address.replace(
            /\s+/g,
            "+"
        )}`;
    }
};
